<!--  -->
<template>
  <div class='privacy' v-html="nodes"></div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      nodes: null
    };
  },
  computed: {},
  watch: {},
  created() {
    this.API.post("Home/article_out-get_protocol", {protocol_type: this.$route.query.type}).then((res) => {
      if (res.errno == 0) {
        this.nodes = res.data.protocol_info
      } else {
        this.$message.error(res.message || '请求失败!')
      }
    });
  },
  mounted() {
    
  },
  //方法集合
  methods: {
    
  },
}
</script>

<style lang='less' scoped>
.privacy {
  padding: 20px;
  /deep/ table {
    width: auto !important;
    max-width: 100% !important;
  }
}
</style>